<template>
  <div class="">
    <el-header style="padding: 0px;display:flex;justify-content:flex-end;align-items: center">
      <select-text v-model="filterParams.cusId" code-set-id="" :options="cusOptions"  placeholder="所属公司" style="width: 200px;margin-right: 10px;"/>
      <el-input v-model="filterParams.empName" placeholder="输入员工姓名搜索" style="width:200px;" clearable=""/>
      <el-button v-waves class="filter-item" type="primary" size="mini" icon="el-icon-search" style="margin-left: -5px;z-index:1" @click="searchProduct()">搜索</el-button>
      <div style="margin-left: 10px;display: inline">
        <el-button
          type="primary"
          size="mini"
          @click="handleAdd">
          新增
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          type="primary"
          size="mini"
          @click="importExcel">
          导入
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          type="primary"
          size="mini"
          @click="exportTable">
          导出
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          :disabled="operDisabled"
          type="success"
          size="mini"
          @click="batchUpdate('1')">
          启用
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          :disabled="operDisabled"
          type="danger"
          size="mini"
          @click="batchUpdate('0')">
          禁用
        </el-button>
      </div>
    </el-header>
    <iTable
      :data="dataList"
      :col-configs="colConfigs"
      :default-sort="{prop: 'createTime',order: 'descending'}"
      :row-class-name="tableRowClassName"
      :row-click="clickRowEvent"
      :max-height="maxHeight"
      :select="selectCheck"
      :show-loading="isLoading"
      :table-key="tableKey"
      :selection-change="handleSelectionChange"
      :filter-change="handleFilterChange"
      :sort-change="handleSortChange"
      itable-loading="loading"
      row-key="id"
    >
      <el-table-column slot="selection" align="center" type="selection" width="50" fixed="left"/>
      <el-table-column slot="index" :formatter="formatterIndex" label="序号" align="center" width="50" fixed="left"/>
      <el-table-column slot="operate" label="操作" width="180" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click.stop="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <!--<el-button type="text" size="small" @click.stop="handleDelete(scope.$index, scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </iTable>
    <el-pagination
      :current-page="page.currentPage"
      :page-sizes="page.pageSizes"
      :total="page.total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"/>
    <!--弹出内容-->
    <add v-if="showAddVisible" ref="add" @refresh="initData"/>
  </div>
</template>
<script>
  import waves from '@/directive/waves'
  import iTable from '@/components/table/index'
  import SelectText from '@/components/SelectText/index.vue'
  import add from './add'
  import { getListpage,batchUpdateStatus,exportEmp,delEmpInfoById } from  "@/api/cus/empinfo"
  import { loadCusList } from  "@/api/cus/cusinfo"
  import { downloadExcelFile } from  "@/util/util"
  export default {
    components: { iTable,SelectText,add },
    directives: { waves },
    data() {
      return {
        showAddVisible: false,
        showAddAdminVisible: false,
        operDisabled: true,
        selection: [], // 选中的数据
        maxHeight: null,
        clientHeight: null,
        dataList: [],
        page: {
          pageSizes: [10,20,30,50],
          total: 0,
          currentPage: 1,
          currentPages: 0,
          pageSize: 10
        },
        isLoading: true,
        dialogVisible: false,
        showFooter: false, // 是否显示弹框的底部按钮
        fixFooter: true, // 是否固定显示组件内的footer按钮
        beginDateScope: '',
        faangledoubleup: 'fa-angle-double-up',
        faangledoubledown: 'fa-angle-double-down',
        filterParams: {
          cusId:'',
          empName: '',
          status: '',
          gender: ''
        },
        tableKey: 'table1', // 区分唯一性  solt渲染时需要对应的key
        cusOptions:[],
      }
    },
    computed: {
      // 注意！！！colConfigs不能放在data 里面，因为当语言切换的时候 他是不会变的 ，要写在computed内
      colConfigs() {
        return [
          { slot: 'selection' }, // 复选框列
          { slot: 'index' }, // 序号列
          { prop: 'empName', label: '员工姓名', align: 'center' },
          { prop: 'idCard', label: '身份证号', align: 'center', width:'150' },
          { prop: 'cusName', label: '企业名称', align: 'center',width:'150' },
          { prop: 'genderTxt', label: '性别', align: 'center' },
         /* { prop: 'birthday', label: '出生日期', align: 'center' },*/
          { prop: 'dept', label: '所属部门', align: 'center' },
          { prop: 'phone', label: '手机', align: 'center',width:'100' },
          { prop: 'email', label: '邮箱', align: 'center' },
          { prop: 'statusTxt', label: '状态', align: 'center' },
          { prop: 'createTime', label: '创建时间', align: 'center', width:'100' },
          { slot: 'operate'} // 操作
        ]
      }
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function() {
        this.changeFixed(this.clientHeight)
      }
    },
    mounted() {
      this.loadCusList()
      this.initData()
    },
    methods: {
      initData() {
        const that = this
        // 获取浏览器可视区域高度
        that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
        window.onresize = function temp() {
          that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
        }
        that.loadProduct()
      },
      loadCusList(){
        loadCusList().then(res => {
          this.cusOptions = res.data.data
        })
      },
      searchProduct() {
        this.page.currentPage = 1
        this.loadProduct()
      },
      // 给行加行号
      tableRowClassName({ row, rowIndex }) {
        // 把每一行的索引放进row
        row.index = rowIndex
      },
      formatterIndex(row, column, cellValue, index) {
        // 放回索引值
        return this.page.currentPages * (this.page.pageSize - 1) + 1 + row.index
      },
      // 点击行事件
      clickRowEvent(row, column, event) {
        console.log(row)
        console.log(column)
        console.log(event)
      },

      // 选中复选框事件
      selectCheck(selection, row) {
        // 你可以这样修改行数据值
        // selection[0].id = '123'
        console.log(selection)
        console.log(row)
      },
      handleSelectionChange(val) {
        this.selection = val
        if (val.length > 0) {
          this.operDisabled = false
        } else {
          this.operDisabled = true
        }
      },
      // 批量发布/禁用
      batchUpdate: function(status) {
        const val = this.selection
        let ids = ''
        for (let i = 0; i < val.length; i++) {
          if (val[i].status !== status) {
            ids += val[i].id + ','
          }
        }
        if (ids) {
          ids = ids.substring(0, ids.lastIndexOf(','))
          const that = this
          let title = '确定要禁用选中员工吗？'
          let title1 = '禁用成功'
          if (status === '1') {
            title = '确定要启用选中员工吗？'
            title1 = '启用成功'
          }
          this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            batchUpdateStatus({ id: ids, status: status }).then((res) => {
              that.$message.success(title1)
              that.loadProduct()
            })
          })
        } else {
          let title1 = '请选择已启用的商品'
          if (status === '1') {
            title1 = '请选择未启用的员工'
          }
          this.$message({
            message: title1,
            type: 'info'
          })
        }
      },
      // 表格最大高自适应
      changeFixed(clientHeight) {
        // 导航栏高65+边距上下30*2+ el-table 链接高40 + 分页高32 = 183
        this.$set(this, 'maxHeight', clientHeight - 197)
      },
      // 页码变化时
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        // 切换成每页20条的数据
        this.page.pageSize = val
        this.isLoading=true
        this.loadProduct()
      },
      // 当前页变化时
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`)
        // 获取table数据
        this.page.currentPage = val
        this.isLoading=true
        this.loadProduct()
      },
      loadProduct() {
        let params = this.filterParams;
        params.page= this.page.currentPage;
        params.limit = this.page.pageSize;
        getListpage(params).then(res => {
          this.page.total = res.data.total
          this.dataList = res.data.records
          this.isLoading = false
        })
      },
      // 当talbel中任何一列的过滤条件点击确定和覆盖时，都会触发此事件。
      handleFilterChange(filters) {
        // 拷贝filters的值。
        for (const i in filters) {
          const row = i // 保存 column-key的值，如果事先没有为column-key赋值，系统会自动生成一个唯一且恒定的名称
          const val = filters[i]
          if (val != null && val.length > 0) {
            this.$set(this.filterParams, row, val[0])
          } else {
            this.$set(this.filterParams, row, '')
          }
        }
        this.currentPage = 1
        this.loadProduct()
      },
      handleSortChange(column){
        console.log(column);
        //获取字段名称和排序类型
        var fieldName = column.prop;
        var sortingType = column.order;
        //如果字段名称为“创建时间”，将“创建时间”转换为时间戳，才能进行大小比较
        if(fieldName=="createTime"){
          this.tableData.map(item => {
            item.createTime = this.$moment(item.createTime).valueOf();
          });
        }
        //按照降序排序
        if(sortingType == "descending"){
          this.tableData = this.tableData.sort((a, b) => b[fieldName] - a[fieldName]);
        }else{ //按照升序排序
          this.tableData = this.tableData.sort((a, b) => a[fieldName] - b[fieldName]);
        }
        //如果字段名称为“创建时间”，将时间戳格式的“创建时间”再转换为时间格式
        if(fieldName=="createTime"){
          this.tableData.map(item => {
            item.createTime = this.$moment(item.createTime).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          });
        }
        console.log(this.tableData);
      },
      // 新增
      handleAdd() {
        this.showAddVisible = true
        this.$nextTick(() => {
          this.$refs.add.init('')
        })
      },
      // 详情
      handleEdit(index, row) {
        this.showAddVisible = true
        this.$nextTick(() => {
          this.$refs.add.init(row.id)
        })
      },
      //删除
      handleDelete(index, row) {
        this.$confirm('删除将无法恢复，确定删除该员工吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delEmpInfoById({id:row.id}).then(res => {
            if(res.data.code==0){
              this.$message.success("删除成功")
              this.initData()
            }
          })
        })
      },
      //导出表格
      exportTable() {
        //exportMethod({columns: this.$refs['accountTable'].tableColums, ...this.listQuery}, '/cus');
        //window.open(process.env.VUE_APP_BASE_API + '/emp/exportEmp', '_parent');
        let that = this;
        exportEmp(this.filterParams).then(res => {
          downloadExcelFile(res,that);
        }).catch(resp => {
          that.$notify.error(resp.msg || '导出失败')
        })
      },
      //导入Excel文件
      importExcel() {
        // 去Excel上传页面
        this.$router.push({
          path: '/emp/batchParent'
        })
      }
    }
  }
</script>
<style scoped>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-input--mini .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
</style>
